import { EXTRA_FAST_FEATURE, SCRIPT_PROOFREADING_FEATURE } from '../../../../../utils/packagesUtils/constants';

export const hideQuantityForExtra = (name) => name === SCRIPT_PROOFREADING_FEATURE || name === EXTRA_FAST_FEATURE;
